import React from "react";

const ArrowIcon = ({ width, height, color }) => {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1003 0.513324L18.5142 6.26255C18.8381 6.58012 19 7.01268 19 7.48905C19 7.96541 18.8381 8.3925 18.5142 8.71555L13.1003 14.4867C12.458 15.1711 11.4108 15.1711 10.7685 14.4867C10.1261 13.8022 10.1261 12.6962 10.7685 12.0118L13.3702 9.25214H1.6571C0.739488 9.25214 0 8.46916 0 7.5C0 6.53085 0.739489 5.74786 1.6517 5.74786H13.3648L10.7631 2.98823C10.1207 2.3038 10.1207 1.19775 10.7631 0.513324C11.4108 -0.171108 12.4526 -0.171108 13.1003 0.513324Z"
        fill="#687CFF"
      />
    </svg>
  );
};
export default ArrowIcon;
